import {
  Pagination,
  PaginationContent,
  PaginationDoubleNext,
  PaginationDoublePrevious,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@/dn-design-system/components/ui/pagination';
import usePagination, { PaginationType } from '@/hooks/common/usePagination';
import { useScrollRestoration } from '@/hooks/useScrollRestoration';
import { addQueryString } from '@/utils/url';

interface Props {
  queries?: Record<string, any>;
  baseUrl: string;
  currentPage: number;
  totalPage: number;
  perPage?: number;
  pageKeyName?: string;
  scroll?: boolean;
  /**
   * 스크롤 복원 기능 활성화 여부
   * - true: 페이지 이동 시 스크롤을 맨 위로, 뒤로가기 시 이전 스크롤 위치 복원
   * - false: 스크롤 복원 기능 비활성화 (브라우저 기본 동작)
   * @default true
   */
  scrollRestoration?: boolean;
}

const PaginationComponent = (props: Props) => {
  const {
    queries,
    baseUrl,
    pageKeyName = 'page',
    scroll = true,
    scrollRestoration = true,
    perPage = 5,
    totalPage,
    currentPage,
  } = props;
  const pageInfos = usePagination(currentPage, totalPage, perPage);

  useScrollRestoration({ ref: undefined, enabled: scrollRestoration });

  return (
    <Pagination>
      <PaginationContent>
        {pageInfos.map((pageInfo) => {
          switch (pageInfo.type) {
            case PaginationType.DOUBLE_PREVIOUS:
              return (
                <PaginationItem key={`pagination-${pageInfo.type}`}>
                  <PaginationDoublePrevious
                    isActive={pageInfo.isActive}
                    scroll={scroll}
                    href={
                      baseUrl +
                      addQueryString({
                        ...queries,
                        [pageKeyName]: pageInfo.page,
                      })
                    }
                  />
                </PaginationItem>
              );
            case PaginationType.PREVIOUS:
              return (
                <PaginationItem key={`pagination-${pageInfo.type}`}>
                  <PaginationPrevious
                    isActive={pageInfo.isActive}
                    scroll={scroll}
                    href={
                      baseUrl +
                      addQueryString({
                        ...queries,
                        [pageKeyName]: pageInfo.page,
                      })
                    }
                  />
                </PaginationItem>
              );
            case PaginationType.LINK:
              return (
                <PaginationItem key={`pagination-${pageInfo.type}-${pageInfo.page}`}>
                  <PaginationLink
                    isActive={pageInfo.isActive}
                    variant={pageInfo.isActive ? 'active' : 'default'}
                    scroll={scroll}
                    href={
                      baseUrl +
                      addQueryString({
                        ...queries,
                        [pageKeyName]: pageInfo.page,
                      })
                    }
                  >
                    {pageInfo.page}
                  </PaginationLink>
                </PaginationItem>
              );
            case PaginationType.NEXT:
              return (
                <PaginationItem key={`pagination-${pageInfo.type}`}>
                  <PaginationNext
                    isActive={pageInfo.isActive}
                    scroll={scroll}
                    href={
                      baseUrl +
                      addQueryString({
                        ...queries,
                        [pageKeyName]: pageInfo.page,
                      })
                    }
                  />
                </PaginationItem>
              );
            case PaginationType.DOUBLE_NEXT:
              return (
                <PaginationItem key={`pagination-${pageInfo.type}`}>
                  <PaginationDoubleNext
                    isActive={pageInfo.isActive}
                    scroll={scroll}
                    href={
                      baseUrl +
                      addQueryString({
                        ...queries,
                        [pageKeyName]: pageInfo.page,
                      })
                    }
                  />
                </PaginationItem>
              );
          }
        })}
      </PaginationContent>
    </Pagination>
  );
};

export default PaginationComponent;
